import HistorizationConsolidateAnalyzeChartsOrganism from "views/organisms/canvases/charts/analyzes/historization/HistorizationConsolidateAnalyzeChartsOrganism"
import HistorizationAnalyzeChartsOrganism from "views/organisms/canvases/charts/analyzes/historization/HistorizationAnalyzeChartsOrganism"
import React from "react"
import PropTypes from "prop-types"

const EnvHistoryAnalyzeOrganism = ({ data }) => {
  if (data.consolidate) {
    return (
      <HistorizationConsolidateAnalyzeChartsOrganism
        score={data.score}
        maturityEvolutionChartData={data.chart_maturity_evolution}
        ghgEvolutionChartData={data.chart_ghg_evolution}
        ghgBreakdownEvolutionChartData={data.chart_ghg_breakdown_evolution}
        maturityDeltaKpi={data.kpi_maturity_delta}
        co2DeltaKpi={data.kpi_co2_delta}
        highestMaturityKpi={data.kpi_highest_maturity_delta}
      />
    )
  }

  return (
    <HistorizationAnalyzeChartsOrganism
      maturity={data.score}
      maturityIndexesesChartData={data.chart_maturity_indexes}
      ghgEvolutionChartData={data.chart_ghg_evolution}
      ghgBreakdownEvolutionChartData={data.chart_ghg_breakdown_evolution}
      kpiMaturityEvolution={data.kpi_maturity_evolution}
      kpiBiggestGhgEvolution={data.kpi_biggest_ghg_evolution}
      kpiBiggestThemeMaturityEvolution={
        data.kpi_biggest_theme_maturity_evolution
      }
    />
  )
}

EnvHistoryAnalyzeOrganism.propTypes = {
  data: PropTypes.object.isRequired,
}

export default EnvHistoryAnalyzeOrganism
